module.exports = __webpack_public_path__ + "components/signup/static/icon-check--white-26e2e881b421ea7251939dffeee9fe7b.svg";